'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCreate$002dRequest$0024$002dInvoice from "./app.data.-App-Document-Data-Create-Request$-Invoice.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataCreateRequest$Invoice$() {
}
export { $c_Lapp_data_AppDocumentDataCreateRequest$Invoice$ as $c_Lapp_data_AppDocumentDataCreateRequest$Invoice$ };
$p = $c_Lapp_data_AppDocumentDataCreateRequest$Invoice$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataCreateRequest$Invoice$;
/** @constructor */
function $h_Lapp_data_AppDocumentDataCreateRequest$Invoice$() {
}
export { $h_Lapp_data_AppDocumentDataCreateRequest$Invoice$ as $h_Lapp_data_AppDocumentDataCreateRequest$Invoice$ };
$h_Lapp_data_AppDocumentDataCreateRequest$Invoice$.prototype = $p;
$p.n = (function() {
  return "Invoice";
});
$p.bKe = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCreate$002dRequest$0024$002dInvoice.$c_Lapp_data_AppDocumentDataCreateRequest$Invoice(x$0.e(0));
});
$p.U = (function(p) {
  return this.bKe(p);
});
var $d_Lapp_data_AppDocumentDataCreateRequest$Invoice$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataCreateRequest$Invoice$, "app.data.AppDocumentDataCreateRequest$Invoice$", ({
  Ap: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentDataCreateRequest$Invoice$ as $d_Lapp_data_AppDocumentDataCreateRequest$Invoice$ };
var $n_Lapp_data_AppDocumentDataCreateRequest$Invoice$;
function $m_Lapp_data_AppDocumentDataCreateRequest$Invoice$() {
  if ((!$n_Lapp_data_AppDocumentDataCreateRequest$Invoice$)) {
    $n_Lapp_data_AppDocumentDataCreateRequest$Invoice$ = new $c_Lapp_data_AppDocumentDataCreateRequest$Invoice$();
  }
  return $n_Lapp_data_AppDocumentDataCreateRequest$Invoice$;
}
export { $m_Lapp_data_AppDocumentDataCreateRequest$Invoice$ as $m_Lapp_data_AppDocumentDataCreateRequest$Invoice$ };
//# sourceMappingURL=app.data.-App-Document-Data-Create-Request$-Invoice$.js.map
